import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/AuthProvider";
import { CurrencyProvider } from "@/lib/CurrencyProvider";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";
import Portal from "@/pages/Portal";
import Admin from "@/pages/Admin";
import Consult from "@/pages/Consult";
import Shop from "@/pages/Shop";
import FarmVisit from "@/pages/FarmVisit";
import AuthCallback from "@/pages/AuthCallback";
import WhatsAppFab from "@/components/WhatsAppFab";
import PWAInstall from "@/components/PWAInstall";
import { Toaster } from "sonner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/consult" element={<Consult />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/farm-visit" element={<FarmVisit />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book" element={<Book />} />
        <Route path="/portal/*" element={<Portal />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <WhatsAppFab />
      <PWAInstall />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CurrencyProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </CurrencyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
